import './$walletsBalances.factory';
import './wallets-balances-api.factory';
import './wallets-requests.service';
import './wallets-service.service';
